import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module.js';
import { ListMyProgressTypesComponent } from './list-my-progress-types.component.js';
import { ProgressTypeFormComponent } from './progress-type-form.component.js';
import { FormModule } from 'lib/ui/form/form.module.js';
import { SubmitProgressMeasurementsComponent } from './submit-progress-measurements.component.js';
import { ProgressGraphsComponent } from './progress-graphs.component.js';

@NgModule({
	imports: [CoreModule, FormModule],
	declarations: [
		ListMyProgressTypesComponent,
		ProgressTypeFormComponent,
		SubmitProgressMeasurementsComponent,
		ProgressGraphsComponent
	],
	exports: [
		ListMyProgressTypesComponent,
		ProgressTypeFormComponent,
		SubmitProgressMeasurementsComponent,
		ProgressGraphsComponent
	]
})
export class ProgressModule {}
